import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, ElementRef, Inject, Input, Renderer2, TemplateRef, ViewChild, inject } from "@angular/core";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { NzMenuGroupComponent } from "ng-zorro-antd/menu";
import { UiIsMenuInsideDropDownToken } from "../../utils/menu.utils";

function MenuGroupFactory(): boolean {
  const isMenuInsideDropDownToken = inject(UiIsMenuInsideDropDownToken, { optional: true, skipSelf: true });
  return isMenuInsideDropDownToken ?? false;
}

@Component({
  selector: "[ui-menu-group]",
  exportAs: "uiMenuGroup",
  templateUrl: "./menu-group.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    /** check if menu inside dropdown-menu component **/
    {
      provide: UiIsMenuInsideDropDownToken,
      useFactory: MenuGroupFactory,
    },
  ],
  standalone: true,
  imports: [NzOutletModule, NgIf],
})
export class UiMenuGroupComponent extends NzMenuGroupComponent {
  @Input("uiTitle") public nzTitle: string | TemplateRef<void>;
  @ViewChild("titleElement") public titleElement?: ElementRef;

  constructor(elementRef: ElementRef, uiRenderer: Renderer2, @Inject(UiIsMenuInsideDropDownToken) public isMenuInsideDropDown: boolean) {
    super(elementRef, uiRenderer, isMenuInsideDropDown);
  }
}
